// Device detection utilities for better iOS/Android detection

export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const isAndroid = () => {
  return /Android/.test(navigator.userAgent);
};

export const isMobile = () => {
  return isIOS() || isAndroid();
};

export const getDeviceInfo = () => {
  return {
    isIOS: isIOS(),
    isAndroid: isAndroid(),
    isMobile: isMobile(),
    userAgent: navigator.userAgent,
    platform: navigator.platform
  };
};

export const logDeviceInfo = () => {
  const info = getDeviceInfo();
  console.log('Device Info:', info);
  return info;
};
